import { useMutation, useQuery } from '@apollo/client'
import { DEFAULT_COUNTRY } from 'constants/countries'
import { logError } from 'logService'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { isUbipharm } from 'utils/origin'
import { isEmail } from 'utils/regex'

import { sendContactForm as SEND_CONTACT_FORM } from '@/graphql/mutations/contactForm'
import { USER } from '@/graphql/queries/user'

import ContactForm from './ContactForm'

const Container = () => {
  const [sendContactForm] = useMutation(SEND_CONTACT_FORM)
  const [form, setForm] = useState({
    lastname: '',
    firstname: '',
    email: '',
    address: '',
    hasTwoReceivers: isUbipharm() ? true : false,
  })
  const [formDataLoaded, setFormDataLoaded] = useState(false)
  const [errors, setErrors] = useState({})

  useQuery(USER, {
    onCompleted: data => {
      if (formDataLoaded || data.me === null) {
        return
      }

      const { firstname, lastname, email } = data.me

      let {
        address,
        address2,
        city,
        zipCode,
        country,
      } = data.me.address

      address = address !== null ? address : ''
      address2 = address2 !== null ? address2 : ''
      city = city !== null ? city : ''
      zipCode = zipCode !== null ? zipCode : ''
      country = country !== null ? country : DEFAULT_COUNTRY

      let fetchedData = {
        firstname,
        lastname,
        email,
        address: `${address} ${address2} ${city} ${zipCode} ${country}`,
      }

      setForm({
        ...form,
        ...fetchedData,
      })

      setFormDataLoaded(true)
    },
  })

  const handleChange = (value, name) => {
    let updatedErrors = { ...errors }

    updateFormValue(value, name)

    setErrors({
      ...updatedErrors,
      [name]: null,
    })
  }

  const updateFormValue = (value, name) => {
    setForm({
      ...form,
      [name]: value,
    })
  }

  const handleSubmit = async e => {
    e.preventDefault()

    const {
      lastname,
      firstname,
      email,
      address,
      hasTwoReceivers,
    } = form
    const updatedErrors = {}

    if (firstname.length === 0) {
      updatedErrors.firstname = 'Champ obligatoire'
    }
    if (lastname.length === 0) {
      updatedErrors.lastname = 'Champ obligatoire'
    }
    if (!isEmail.test(email)) {
      updatedErrors.email = 'Champ incorrect'
    }
    if (address.length === 0) {
      updatedErrors.address = 'Champ obligatoire'
    }

    setErrors(updatedErrors)
    const hasError = Object.values(updatedErrors).some(error => typeof error === 'string')

    if (!hasError) {
      try {
        await sendContactForm({
          variables: {
            firstname,
            lastname,
            email,
            address,
            hasTwoReceivers,
          },
        })

        toast.success('Formulaire envoyé avec succès', {
          position: 'top-center',
        })
      } catch (error) {
        toast.error('Une erreur est survenue', {
          position: 'top-center',
        })
        logError('GRAPHQL', 'sendContactForm', error)
      }
    }
  }

  return (
    <ContactForm
      errors={ errors }
      form={ form }
      onChange={ handleChange }
      onSubmit={ handleSubmit }
    />
  )
}

export default Container
